module.exports = __webpack_public_path__ + "assets/img/paperwalletemptyA.f97adf0454d18df8539c310a6387b3e6.svg";